// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609140420/js/" + chunkId + "." + {"44":"878604b6","225":"0c8eadd1","481":"90470251","486":"08ff5bc6","770":"0faab4b3"}[chunkId] + ".0.9918145943612575.chunk.js";
};